import { render, staticRenderFns } from "./WholesaleSellingInfoForm.vue?vue&type=template&id=15f8263f&scoped=true&"
import script from "./WholesaleSellingInfoForm.vue?vue&type=script&lang=js&"
export * from "./WholesaleSellingInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f8263f",
  null
  
)

export default component.exports